
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ProfileModel } from '@/models/user.model';
import { userState } from '@/utils/store-acessor';
import { AuthApi } from '@/api/auth.api';
import { take } from 'rxjs/operators';
import { authModule, authState } from '@/utils/store-acessor';

@Component({})
export default class AcceptTermsAndPolicies extends Vue {
  termsOfUseCheck: boolean = false;
  privacyPolicyCheck: boolean = false;
  showLoading: boolean = false;
  goToHome: boolean = false;

  snackbarVisibility: boolean = false;
  snackbarColor: string | null = null;
  snackbarText: string = '';

  @authModule.Mutation('authenticationSuccess') authSuccess: any;

  @Prop({ default: '' })
  type!: 'facebook' | 'linkedin' | 'google';

  @Prop({ default: '' })
  token!: string;

  get canProceed(): boolean {
    return this.termsOfUseCheck && this.privacyPolicyCheck ? false : true;
  }

  openTermsAndPolicy(link?: string) {
    window.open(link, '_blank');
  }

  onBackToHome() {
    this.$router.push({ name: 'home' });
  }

  async finishRegister() {
    if (this.termsOfUseCheck && this.privacyPolicyCheck) {
      this.showLoading = true;
      this.sendAuthToServer(true, this.token, this.type);
    }
  }

  private sendAuthToServer(
    accept_terms: boolean,
    token: string,
    type: 'facebook' | 'linkedin' | 'google'
  ) {
    new AuthApi()
      .signInWithSocial(token, type, accept_terms)
      .pipe(take(1))
      .subscribe(
        res => {
          this.authSuccess(res);
          this.showLoading = false;
          this.goToHome = true;
          this.snackbarVisibility = true;
          this.snackbarColor = 'green';
          this.snackbarText = this.$t(
            'auth.titles.account_has_validated'
          ).toString();
        },
        error => {
          this.snackbarVisibility = true;
          this.snackbarColor = 'red';
          this.snackbarText = this.$t(
            'auth.titles.account_has_not_validated'
          ).toString();
        }
      );
  }
}
